const Label = ({ msg }) => {
  return <div className="label">{msg}</div>;
};

export default Label;
